import React from "react"; // Import React to create the component
import "../css/LoginPage.css";
import Footer from "./Footer";
import NavigationBar from "./NavigationBar";
import { Link } from "react-router-dom";

const RegistrationPage = () => {
  const [firstName, setFirstName] = React.useState("");
  const [lastName, setLastName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [passwordStrength, setPasswordStrength] = React.useState("");
  const evaluatePasswordStrength = (pwd) => {
    const strongRegex = /^(?=.*[A-Z])(?=.*[^a-zA-Z0-9]).{10,}$/;
    if (pwd.length === 0) {
      setPasswordStrength("");
    } else if (!strongRegex.test(pwd)) {
      setPasswordStrength("weak");
    } else if (pwd.length >= 10 && pwd.length <= 12) {
      setPasswordStrength("medium");
    } else {
      setPasswordStrength("strong");
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const confirmPassword = e.target[4].value;

    const passwordRegex = /^(?=.*[A-Z])(?=.*[^a-zA-Z0-9]).{10,}$/;

    if (!passwordRegex.test(password)) {
      alert(
        "Password must be at least 10 characters long and include at least one uppercase letter and one special character."
      );
      return;
    }

    if (password !== confirmPassword) {
      alert("Passwords do not match. Please try again.");
      setPassword("");
      e.target[4].value = ""; // Reset confirm password field
      return;
    }

    fetch("https://18.117.231.157/api/signup", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        firstName,
        lastName,
        email,
        password,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success == true) {
          alert(`Registered as ${firstName} ${lastName}`);
          window.location.href = "/login"; // Redirect to login page
          // Clear form only on success
          setFirstName("");
          setLastName("");
          setEmail("");
          setPassword("");
          e.target[4].value = ""; // Reset confirm password manually
        } else {
          alert("Registration failed: " + data);
          console.log("Server response is:", data);
        }
      })
      .catch((error) => {
        console.error(
          "Backend Server is not running, Please reach out to admin",
          error.name
        );
        alert("Backend Server is not running, Please reach out to admin.");
      });
  };

  return (
    <div>
      <NavigationBar />
      <br />
      <br />
      <br />
      <br />
      <br />
      <h1 className="contactuspageheaders">Sign Up</h1>
      <br />
      <form className="loginform" onSubmit={handleSubmit}>
        <label htmlFor="firstname">First Name</label>
        <input
          type="text"
          id="firstname"
          name="firstname"
          onInvalid={(e) =>
            e.target.setCustomValidity("Please enter your first name.")
          }
          onChange={(e) => setFirstName(e.target.value)}
          onInput={(e) => e.target.setCustomValidity("")}
          value={firstName}
          required
        />

        <label htmlFor="lastname">Last Name</label>
        <input
          type="text"
          id="lastname"
          name="lastname"
          onInvalid={(e) =>
            e.target.setCustomValidity("Please enter your last name.")
          }
          onChange={(e) => setLastName(e.target.value)}
          onInput={(e) => e.target.setCustomValidity("")}
          value={lastName}
          required
        />

        <label htmlFor="email">Email</label>
        <input
          type="text"
          id="email"
          name="email"
          onInvalid={(e) =>
            e.target.setCustomValidity("Please enter a valid email address.")
          }
          onChange={(e) => setEmail(e.target.value)}
          onInput={(e) => e.target.setCustomValidity("")}
          value={email}
          required
        />

        <label htmlFor="password">Password</label>
        <input
          type="password"
          id="password"
          name="password"
          onInvalid={(e) =>
            e.target.setCustomValidity("Please enter your password.")
          }
          onChange={(e) => {
            const val = e.target.value;
            setPassword(val);
            evaluatePasswordStrength(val);
          }}
          onInput={(e) => {
            e.target.setCustomValidity("");
            const val = e.target.value;
            setPassword(val);
            evaluatePasswordStrength(val);
          }}
          value={password}
          required
        />

        {passwordStrength && (
          <div style={{ marginBottom: "10px" }}>
            <span
              style={{
                fontWeight: "bold",
                color:
                  passwordStrength === "weak"
                    ? "red"
                    : passwordStrength === "medium"
                    ? "orange"
                    : "green",
              }}
            >
              Password strength: {passwordStrength}
            </span>
          </div>
        )}

        <label htmlFor="confirmPassword">Confirm Password</label>
        <input
          type="password"
          id="confirmPassword"
          name="confirmPassword"
          onInvalid={(e) =>
            e.target.setCustomValidity("Please re-enter your password.")
          }
          onInput={(e) => e.target.setCustomValidity("")}
          required
        />
        <br />
        <button type="submit" className="loginbutton">
          Sign Up
        </button>
      </form>

      <div className="overlap">
        <div className="main">
          <h1>Already a member?</h1>
        </div>
        <div className="sub">
          <h1>
            Login
            <br />
            Here
          </h1>
        </div>
      </div>

      <div className="signup">
        <Link
          className="signupbutton"
          to="/login"
          style={{ textAlign: "center" }}
        >
          Login
        </Link>
      </div>

      <br />
      <br />
      <br />
      <br />
      <Footer />
    </div>
  );
};

export default RegistrationPage;
